import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import RevenueScopeSwitch from '@intelligence/components/RevenueScopeSwitch';

export const MOBILE_STATS_REVENUE_SCOPE_SLOT_ID =
  'dbi-mobile-stats-revenue-scope-slot';

interface IMobileStatsRevenueScopePortalProps {
  value?: string;
  onChange: (value: string) => void;
}

export default function MobileStatsRevenueScopePortal(
  props: IMobileStatsRevenueScopePortalProps,
) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setSlot(document.getElementById(MOBILE_STATS_REVENUE_SCOPE_SLOT_ID));
  }, []);

  if (!slot) {
    return null;
  }

  return createPortal(<RevenueScopeSwitch {...props} />, slot);
}
